<form [formGroup]="Form" novalidate (submit)="sumbitFormButton($event)">
    <div *ngIf="!hidden">
        <div class="mat-panel">
            <div id="form" class="row">
                <div class="col-12{{ inModal ? '' : (' col-sm-6 col-md-4 col-lg-'+(12/colNo))}}"
                    *ngFor="let key of keys; let i= index" [hidden]="columnsForm[key].hidden">

                    <div *ngIf="i%colNo===0" class="w-100 d-none d-lg-block"></div>
                    <div *ngIf="i%3===0" class="w-100 d-none d-md-block d-lg-none"></div>
                    <div *ngIf="i%2===0" class="w-100 d-none d-sm-block d-md-none"></div>
                    <div *ngIf="i%1===0" class="w-100 d-block d-sm-none"></div>

                    <div *ngIf="columnsForm[key]" [hidden]="columnsForm[key].hidden">

                        <div *ngIf="columnsForm[key].type == 'paragraph'" [innerHTML]=columnsForm[key].label>
                        </div>

                        <mat-form-field *ngIf="columnsForm[key].type == 'text'"
                            [ngClass]="{'w-100': inModal, 'form-field-readonly': columnsForm[key].readonly || readonly}">
                            <input name="{{key || columnsForm[key].name}}"
                                [attr.maxlength]="columnsForm[key].attr ? columnsForm[key].attr?.maxlength : null"
                                (keydown.enter)="enter()" type="{{columnsForm[key].type}}" matInput
                                formControlName="{{columnsForm[key].nombreService || key}}"
                                [placeholder]="columnsForm[key]?.validators?.includes('required') && !columnsForm[key]?.label?.includes('*') ? columnsForm[key].label + ' *' : columnsForm[key].label"
                                [readonly]="columnsForm[key].readonly || readonly"
                                autocomplete="{{columnsForm[key].autocomplete || columnsForm[key].name}}">
                            <mat-error
                                *ngIf="getErrorMessage((columnsForm[key].nombreService || key), i).length">{{getErrorMessage((columnsForm[key].nombreService
                                || key), i)[0]}}</mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="columnsForm[key].type == 'int'"
                            [ngClass]="{'w-100': inModal, 'form-field-readonly': columnsForm[key].readonly || readonly}">
                            <input name="{{key || columnsForm[key].name}}" (keydown.enter)="enter()" type="number"
                                matInput formControlName="{{columnsForm[key].nombreService || key}}"
                                [attr.max]="columnsForm[key].attr?.max" [attr.min]="columnsForm[key].attr?.min"
                                [placeholder]="columnsForm[key]?.validators?.includes('required') && !columnsForm[key]?.label?.includes('*') ? columnsForm[key].label + ' *' : columnsForm[key].label"
                                [readonly]="columnsForm[key].readonly || readonly"
                                autocomplete="{{columnsForm[key].autocomplete || columnsForm[key].name}}">
                            <mat-error
                                *ngIf="getErrorMessage((columnsForm[key].nombreService || key), i).length">{{getErrorMessage((columnsForm[key].nombreService
                                || key), i)[0]}}</mat-error>
                        </mat-form-field>
                        <mat-form-field
                            *ngIf="(columnsForm[key].type == 'password' || columnsForm[key].type == 'pPassword')"
                            [ngClass]="{'w-100': inModal, 'mat-form-field-password': true}">
                            <input name="{{key || columnsForm[key].name}}" (keydown.enter)="enter()"
                                [ngClass]="{'pass-input': true}" [type]="hidePass ? 'password' : 'text'" matInput
                                [placeholder]="columnsForm[key]?.validators?.includes('required') && !columnsForm[key]?.label?.includes('*') ? columnsForm[key].label + ' *' : columnsForm[key].label"
                                [readonly]="columnsForm[key].readonly || readonly"
                                formControlName="{{columnsForm[key].nombreService || key}}"
                                autocomplete="{{columnsForm[key].autocomplete || columnsForm[key].name}}">
                            <i class="material-icons pointer" matSuffix (click)="hidePass = !hidePass">{{hidePass ?
                                'visibility' : 'visibility_off'}}</i>
                            <mat-error
                                *ngIf="getErrorMessage((columnsForm[key].nombreService || key), i).length">{{getErrorMessage((columnsForm[key].nombreService
                                || key), i)[0]}}</mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="columnsForm[key].type == 'textarea'" [ngClass]="{'w-100': inModal}">
                            <textarea name="{{key || columnsForm[key].name}}" matInput
                                placeholder="{{columnsForm[key].label}}"
                                [attr.maxlength]="columnsForm[key].attr?.maxlength"
                                [formControl]="Form.get((columnsForm[key].nombreService || key))"
                                [readonly]="columnsForm[key].readonly || readonly"></textarea>
                        </mat-form-field>

                        <mat-form-field *ngIf="columnsForm[key].type == 'time'"
                            [ngClass]="{'w-100': inModal, 'form-field-readonly': columnsForm[key].readonly || readonly}">
                            <input name="{{key || columnsForm[key].name}}" (keydown.enter)="enter()"
                                type="{{columnsForm[key].type}}" matInput
                                formControlName="{{columnsForm[key].nombreService || key}}"
                                [placeholder]="columnsForm[key]?.validators?.includes('required') && !columnsForm[key]?.label?.includes('*') ? columnsForm[key].label + ' *' : columnsForm[key].label"
                                [readonly]="columnsForm[key].readonly || readonly">
                        </mat-form-field>

                        <mat-checkbox name="{{key || columnsForm[key].name}}" class="form-checkbox"
                            *ngIf="columnsForm[key].type == 'checkbox'"
                            formControlName="{{columnsForm[key].nombreService || key}}">
                            <div *ngIf="!columnsForm[key].customHtml">
                                {{columnsForm[key]?.validators?.includes('required') &&
                                !columnsForm[key]?.label?.includes('*') ? columnsForm[key].label + ' *' :
                                columnsForm[key].label}}</div>
                            <div *ngIf="columnsForm[key].customHtml" [innerHTML]=columnsForm[key].label></div>
                        </mat-checkbox>

                        <div *ngIf="columnsForm[key].type == 'date'">
                            <div class="inputDatePicker">
                                <ng-container *ngIf="!columnsForm[key].attr?.options.dateRange">
                                    <mat-form-field>
                                        <mat-label>{{columnsForm[key].label}}</mat-label>
                                        <input [value]="columnsForm[key].value" matInput [matDatepicker]="picker"
                                            (dateInput)="selectedDate($event)"
                                            (dateChange)="selectedDate($event, columnsForm[key], false)">
                                        <mat-datepicker-toggle class="iconCalendar" matIconSuffix
                                            [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </ng-container>
                                <ng-container *ngIf="columnsForm[key].attr?.options.dateRange">
                                    <mat-form-field>
                                        <input (click)="dp.toggleCalendar()" matInput
                                            placeholder="{{columnsForm[key].label}}" angular-mydatepicker
                                            name="{{key || columnsForm[key].name}}"
                                            [locale]="columnsForm[key].attr?.options.locale"
                                            [options]="columnsForm[key].attr?.options ? columnsForm[key].attr?.options : options"
                                            [readonly]="columnsForm[key].readonly || readonly" onkeydown="return false"
                                            #dp="angular-mydatepicker"
                                            (dateChanged)="selectedDateRange($event, columnsForm[key], columnsForm[key].attr?.options.dateRange)"
                                            [value]="columnsForm[key].attr?.options.dateRange ? columnsForm[key].value && columnsForm[key].value[0] && columnsForm[key].value[1] ? (((columnsForm[key].value[0])|date:columnsForm[key].formatDate) + ' - '+ ((columnsForm[key].value[1])|date:columnsForm[key].formatDate)) : '' : (columnsForm[key].value|date:columnsForm[key].formatDate)" />
                                    </mat-form-field>
                                    <button class="buttonCalendar" mat-icon-button id="buttonShow"
                                        [color]="color ? null : 'primary'" [style.color]="color"
                                        (click)="dp.toggleCalendar()">
                                        <i class="material-icons iconoCalendar">date_range</i>
                                    </button>
                                </ng-container>
                            </div>
                        </div>

                        <iv-select *ngIf="columnsForm[key].type == 'select'"
                            [required]="columnsForm[key]?.validators?.includes('required')"
                            [name]="(columnsForm[key].nombreService || key)" ngDefaultControl
                            [formControl]="Form.get((columnsForm[key].nombreService || key))"
                            [label]="columnsForm[key].label" [data]="columnsForm[key].options"
                            (selectionChange)="changeSelect($event, columnsForm[key].nombreService || key)"
                            [ngClass]="{'w-100': inModal}" [fullWidth]="inModal" [errors]="errorMessages"
                            [groups]="columnsForm[key].groups">
                        </iv-select>

                        <iv-select *ngIf="columnsForm[key].type == 'selectmultiple' "
                            [required]="columnsForm[key]?.validators?.includes('required')"
                            [name]="(columnsForm[key].nombreService || key)" ngDefaultControl
                            [formControl]="Form.get((columnsForm[key].nombreService || key))"
                            [label]="columnsForm[key].label" [data]="columnsForm[key].options"
                            (selectionChange)="changeSelectMultiple($event, columnsForm[key].nombreService || key)"
                            [multiple]="true" [ngClass]="{'w-100': inModal}" [fullWidth]="inModal"
                            [errors]="errorMessages" [groups]="columnsForm[key].groups">
                        </iv-select>

                        <iv-select *ngIf="columnsForm[key].type == 'prefixes' "
                            [required]="columnsForm[key]?.validators?.includes('required')"
                            [name]="(columnsForm[key].nombreService || key)" ngDefaultControl
                            [formControl]="Form.get((columnsForm[key].nombreService || key))"
                            [label]="columnsForm[key].label" [data]="columnsForm[key].options"
                            (iconClick)="onIconClick($event)"
                            (selectionChange)="changeSelectMultiple($event, columnsForm[key].nombreService || key)"
                            [multiple]="true" [ngClass]="{'w-100': inModal}" [fullWidth]="inModal"
                            [errors]="errorMessages" [groups]="columnsForm[key].groups">
                        </iv-select>

                        <iv-select-menu *ngIf="columnsForm[key].type == 'selectmenu'"
                            [required]="columnsForm[key]?.validators?.includes('required')"
                            [name]="(columnsForm[key].nombreService || key)" ngDefaultControl
                            [formControl]="Form.get((columnsForm[key].nombreService || key))"
                            [label]="columnsForm[key].label" [submenu]="columnsForm[key].submenu"
                            [data]="columnsForm[key].options" (selectionChange)="changeSelectMenu($event, key)"
                            [ngClass]="{'w-100': inModal}" [fullWidth]="inModal">
                        </iv-select-menu>

                    </div>
                </div>
            </div>
        </div>

        <div id="btn" class="form-action-bar d-flex" *ngIf="buttons && !footerbarKeys.length">
            <signaturit-button *ngIf="buttons.clear" class="buttons" text="{{labels.clear}}" type="tertiary" size="md"
                (click)="clearForm($event)"></signaturit-button>
            <signaturit-button *ngIf="buttons.save" class="buttons" text="{{labels.submit}}" type="primary" size="md"
                (click)="sendForm()"></signaturit-button>
        </div>
        <div [class]="footerbarKeys.length > 2 ? 'form__actions' : 'form__actions-small'"
            *ngIf="footerbarKeys && footerbarKeys.length">
            <signaturit-button *ngIf="footerbar?.clean" [text]="footerbar?.clean?.label" [type]="'tertiary'"
                [size]="'md'" (click)="onClickFootbar('clean')"
                [disabled]="footerbar?.clean?.disabled"></signaturit-button>
            <div class="actions__right">
                <ng-container *ngFor="let key of footerbarKeys; let i = index">
                    <signaturit-button *ngIf="key !== 'clean'" [text]="footerbar[key].label"
                        [type]="key === 'save' ? 'secondary' : 'tertiary'" [size]="'md'" (click)="onClickFootbar(key)"
                        [disabled]="footerbar[key].disabled"></signaturit-button>
                </ng-container>
            </div>
        </div>

    </div>
</form>
